import React, {useEffect} from 'react'
import TextArea from "../../assessment/inputtypes/TextArea";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import AssessmentAnswersTable from "../assessments/AssessmentAnswersTable";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import {DeleteOutlined, LinkOutlined} from "@ant-design/icons";
import {Rest} from "../../../../util/rest";
import {toast} from "react-toastify";
import {withUser} from "../../../../context/UserContext";
import AssessmentTemplateQuestionDependencyEditor from "./AssessmentTemplateQuestionDependencyEditor";
import _ from "lodash";

import MatrixColumnsEditor from "./MatrixColumnsEditor";
import MatrixRowsEditor from "./MatrixRowsEditor";

const inputLabelProps = {
    classes: {
        root: 'textField',
        focused: 'focused'
    },
    shrink: true
};

const AssessmentTemplateQuestionV2 = (props) => {

    const [question, setQuestion] = React.useState(props.question);
    const [dependencyEditor, setDependencyEditor] = React.useState(false);

    useEffect(() => {
        if(!_.isEqual(question, props.question) || question.id === 0)
            save();
    }, [question]);

    useEffect(() => {
        if(!_.isEqual(question, props.question))
            setQuestion(props.question);
    }, [props.question]);

    const handleChange = (event) => {
        let {name, value, type} = event.target;
        if(type === "number") {
            value = parseInt(value)
        }
        else if(type === "checkbox") {
            value = !question.required
        }
        setQuestion(prev => ({...prev, [name]: value}));
    }

    const handleUpdateAnswers = (answers) => {
        setQuestion(prev => ({...prev, answers}));
    }

    const handleDependencySelected = (questions) => {
        if(questions?.length > 0) {
            const dependencies = questions.map((q) => ({
                id: 0,
                assessmentTemplateQuestionId: q.dependencyId,
                assessmentTemplateDependentQuestionId: q.dependentQuestionId,
                assessmentTemplateAnswerId: q.dependentAnswerId,
                answerNumeric: q.dependentNumericAnswer,
                answerDate: q.dependentDateAnswer,
                answerText: q.dependentTextAnswer,
                operator: q.dependentOperator,
                not: q.dependentNot
            }))
            setQuestion({...question, dependencies: dependencies});
        }
        else {
            setQuestion({...question, dependencies: []});
        }
    }

    const save = () => {
        if(!props.readOnly) {
            const url = "/rest/assessment/templates/question";
            Rest.authFetch(props.user, url, {
                method: "PUT",
                body: JSON.stringify(question)
            })
                    .then(response => {
                        if(response) {
                            const originalId = question.id;
                            setQuestion(response);
                            if(props.onChange)
                                props.onChange(originalId, response);
                        }
                        else {
                            toast.error("Error saving Question");
                        }
                    }).catch(error => {
                toast.error("Error saving Question");
                console.log(error);
            });

        }
    }

    const handleMouseLeave = () => {
        if(props.question !== question) {
            save()
        }
    }

    const handleDelete = () => {
        const originalId = question.id;
        Rest.authFetch(props.user, `/rest/assessment/templates/question/${question.id}`, {
            method: "DELETE"
        })
                .then(response => {
                    if(response.status === 401 || response.status === 403) {
                        toast.error("Unauthorized user!")
                    }
                    else if(props.onDelete) {
                        props.onDelete(originalId);
                    }
                });
    }

    return (
            <div className={"d-flex justify-content-between"} onMouseLeave={handleMouseLeave}>
                <div className="my-auto mx-2">{props.index + 1}.</div>
                <div className="container-fluid agendaItem shadow-sm border">
                    <div className="row">
                        <div className="col-md-3 my-auto">
                            <TextArea
                                    autoFocus
                                    defaultValue={question.question}
                                    label={"Question"}
                                    name={"question"}
                                    rows={9}
                                    readOnly={props.readOnly}
                                    onBlur={handleChange}
                            />
                        </div>
                        <div className="col-md-8">
                            <div className={"row mb-3"}>
                                <div className={"col-md-4"}>
                                    <FormControl variant="outlined" fullWidth>
                                        <InputLabel>Question Type</InputLabel>
                                        <Select
                                                onChange={handleChange}
                                                name={"questionType"}
                                                value={question.questionType}
                                                className={"textField bg-white"}
                                                disabled={props.readOnly}
                                                variant="outlined"
                                        >
                                            <MenuItem value={"FREE_TEXT"}>Free Text</MenuItem>
                                            <MenuItem value={"SELECTION"}>Selection</MenuItem>
                                            <MenuItem value={"MULTIPLE_SELECTION"}>Multiple Selection</MenuItem>
                                            <MenuItem value={"RANGE"}>Range</MenuItem>
                                            <MenuItem value={"NUMERIC_VALUE"}>Numeric Value</MenuItem>
                                            <MenuItem value={"DATE"}>Date</MenuItem>
                                            <MenuItem value={"TABLE"}>Table (Matrix)</MenuItem>
                                        </Select>
                                    </FormControl>
                                </div>
                                <div className="col-md-2">
                                    <TextField
                                            label="Weight"
                                            variant="outlined"
                                            name={"weight"}
                                            type="number"
                                            onBlur={handleChange}
                                            defaultValue={question.weight}
                                            InputLabelProps={inputLabelProps}
                                            className="textField"
                                            inputProps={{readOnly: props.readOnly}}
                                    />
                                </div>
                                {(question.questionType === "RANGE" || 
                                  question.questionType === "NUMERIC_VALUE" || 
                                  question.questionType === "TABLE") &&
                                    <>
                                        <div className="col-md-2">
                                            <TextField
                                                    label="Min"
                                                    type="number"
                                                    name={"min"}
                                                    onBlur={handleChange}
                                                    defaultValue={question.min}
                                                    InputLabelProps={inputLabelProps}
                                                    className="textField"
                                                    variant="outlined"
                                                    inputProps={{readOnly: props.readOnly}}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <TextField
                                                    label="Max"
                                                    type="number"
                                                    name={"max"}
                                                    onBlur={handleChange}
                                                    defaultValue={question.max}
                                                    InputLabelProps={inputLabelProps}
                                                    className="textField"
                                                    variant="outlined"
                                                    inputProps={{readOnly: props.readOnly}}
                                            />
                                        </div>
                                        {  question.questionType === "RANGE" &&
                                        <div className="col-md-2">
                                            <TextField
                                                    label="Step"
                                                    type="number"
                                                    name={"steps"}
                                                    onBlur={handleChange}
                                                    defaultValue={question.steps}
                                                    InputLabelProps={inputLabelProps}
                                                    className="textField"
                                                    variant="outlined"
                                                    inputProps={{readOnly: props.readOnly}}
                                            />
                                        </div>
                                        }
                                        {question.questionType === "TABLE" && (
                                        <>
                                            <MatrixColumnsEditor
                                            columns={question.matrixColumns || []}
                                            onUpdate={(cols) => {
                                                const normalized = cols.map((c, i) => ({ ...c, order: i + 1 }));
                                                setQuestion(prev => {
                                                    const currentRows = (prev.answers || []);
                                                    const rows = currentRows.map(r => {
                                                        const cells = [...(r.matrixCells || [])];
                                                        const byId = new Map(cells.filter(x => x.columnId).map(x => [x.columnId, x]));
                                                        const byCode = new Map(cells.filter(x => x.columnCode).map(x => [x.columnCode, x]));
                                                        const nextCells = normalized.map(col => {
                                                            const found = (col.id && byId.get(col.id)) || byCode.get(col.code);
                                                            return found ? found : { id: 0, columnId: col.id || null, columnCode: col.code, description: "" };
                                                        });
                                                        return { ...r, matrixCells: nextCells };
                                                    });
                                                    return { ...prev, matrixColumns: normalized, answers: rows };
                                                });
                                            }}
                                            readOnly={props.readOnly}
                                            />

                                            <MatrixRowsEditor
                                            rows={question.answers || []}
                                            columns={question.matrixColumns || []}
                                            onUpdate={(rows) => handleUpdateAnswers(rows)}
                                            readOnly={props.readOnly}
                                            />
                                        </>
                                        )}

                                    </>
                                }
                            </div>
                            <div className={"row"}>
                                <div className={"col-md-7"}>
                                    {(question.questionType === "SELECTION" || 
                                      question.questionType === "MULTIPLE_SELECTION" ||
                                      question.questionType === "TABLE") &&
                                        <AssessmentAnswersTable
                                                answers={question.answers}
                                                onUpdateAnswers={handleUpdateAnswers}
                                                questionId={question.id}
                                                readOnly={props.readOnly}
                                        />
                                    }
                                </div>
                                <div className={"col-md-5"}>
                                    <div className={"row"}>
                                        <div className={"col-md-12 mt-4"}>
                                            {/* Todo: display the dependencies    */}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"col-md-1 text-center"}>
                            <div className={"row mb-5"}>
                                <FormControlLabel
                                        classes={{root: 'FormControlLabel'}}
                                        label={"Required"}
                                        control={
                                            <Checkbox
                                                    classes={{root: 'Checkbox', checked: "checked"}}
                                                    name={"required"}
                                                    checked={question.required}
                                                    onChange={handleChange}
                                                    disabled={props.readOnly}
                                            />
                                        }
                                />
                            </div>
                             <>
                            {!props.readOnly &&
                                 <div className="edit row">
                                     <DeleteOutlined className={"mx-auto"} title="Delete Question"
                                                     onClick={() => handleDelete(question.id)}/>
                                 </div>
                            }
                                 <div className="edit row">
                                     <LinkOutlined type="link"
                                                   className={"mx-auto" + (question.dependencies?.length > 0 ? " dependencies-exist" : "")}
                                                   title={"Dependencies"}
                                                   onClick={() => setDependencyEditor(true)}/>
                                 </div>
                             </>
                        </div>
                    </div>
                </div>
                <AssessmentTemplateQuestionDependencyEditor open={dependencyEditor}
                                                            onClose={setDependencyEditor}
                                                            question={question}
                                                            readOnly={props.readOnly}
                                                            handleDependencySelected={handleDependencySelected}/>
            </div>

    )
}

export default withUser(AssessmentTemplateQuestionV2);